module.exports = __webpack_public_path__ + "static/ceremony-render-6a39063661a86c0ebced399d2a39deec.jpg";